import apidocumentoszip from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apidocumentoszip.get('documentos', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async createZip(_, { postParams }) {
      const p = postParams;
      console.log(p);
      const [{ data }] = await Promise.all([
        apidocumentoszip.post('documentoszip', { ...postParams }),
      ]);

      return data;
    },

    async deleteZipExpirado() {
      console.log('aaa');
      await Promise.all([apidocumentoszip.delete('documentoszip/all/expiracao')]);
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
